import { object } from "prop-types";

const UPDATE_CURRENT_PAGE="updateCurrentPage";
const UPDATE_SEARCH_TYPE="updateSearchType";
const UPDATE_SEARCH_INPUT="updateSearchInput";
const UPDATE_PAGE_INPUT="updatePageInput";
const initialState = {
    pageNumber:1,
    searchType:0,
    searchInput:'',
    pageInput:''
}
const reducer = function(state = initialState, action) {
    let { type, params } = action;
    switch (type) {
        case UPDATE_CURRENT_PAGE:return Object.assign({},state,{
            pageNumber:params
        })
        case UPDATE_SEARCH_TYPE:return Object.assign({},state,{
            searchType:params
        })
        case UPDATE_SEARCH_INPUT:return Object.assign({},state,{
            searchInput:params
        })
        case UPDATE_PAGE_INPUT:return Object.assign({},state,{
            pageInput:params
        })
        default: return state;
    }
}

export {
    reducer as default,
    initialState as pageInitialState
}
